import sliders from '../../../src/js/shared/sliders';

'use strict';

const $ = jQuery.noConflict();
$(function() {

	const sliderLookaround = {

		init: function() {
			this.cacheDOM();
			this.sliderInit();
		},

		cacheDOM: function() {
			this.$slider = $('.js-slider-lookaround');
			this.$prevArrow = $('.js-slider-lookaround-prev');
			this.$nextArrow = $('.js-slider-lookaround-next');
		},

		sliderInit: function() {
			if (!this.$slider.length) return;

			const sliderConfig = {
				slidesToShow: 2,
				slidesToScroll: 1,
				infinite: false,
				autoplay: false,
				arrows: true,
				prevArrow: this.$prevArrow,
				nextArrow: this.$nextArrow,
				responsive: [
					{
						breakpoint: 991,
						settings: {
							slidesToShow: 1.4,
						}
					},
					{
						breakpoint: 575,
						settings: {
							slidesToShow: 1.1,
						}
					}
				]
			};

			sliders.initializeSlider('.js-slider-lookaround', sliderConfig);
		},

	};

	sliderLookaround.init();

});
